module.exports = __webpack_public_path__ + "media/images/logo-mail-ffa9300981ee501ddb635acaa0bf07e4.png";